export default __webpack_public_path__ + "static/media/gas-station.2f447969.svg";